/**
 * Donation campaign content.
 * Rendered by <DonationSection/>. All values are static placeholders for now;
 * swap `percent`, `raised`, `goal`, donor counts and media for live data later.
 */
const donationData = {
    en: {
        // Collage images around the DONATE headline, swap for real media.
       images: [
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
        ],
        title: 'Section Title',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        eyebrow: 'Section Title',
        headingPre: 'Together, we build a',
        headingScript: 'stronger',
        headingPost: 'future.',
        goalLabel: 'GOAL',
        percent: 72,
        raised: '$24,000',
        goal: 'of $48,000',
        donorExtra: '+47',
        donorAvatars: [
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
        ],
        membersPre: 'Join',
        membersHighlight: '230+',
        membersPost: 'amazing members who already support our community.',
        ctaText: 'DONATE NOW',
        donateUrl: 'https://www.example.com',
        secureNote: 'Secure & Tax Deductible',
    },
    he: {
       images: [
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
        ],
        title: 'Section Title',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        eyebrow: 'Section Title',
        headingPre: 'Together, we build a',
        headingScript: 'stronger',
        headingPost: 'future.',
        goalLabel: 'GOAL',
        percent: 72,
        raised: '$24,000',
        goal: 'of $48,000',
        donorExtra: '+47',
        donorAvatars: [
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
            '/placeholder.svg',
        ],
        membersPre: 'Join',
        membersHighlight: '230+',
        membersPost: 'amazing members who already support our community.',
        ctaText: 'DONATE NOW',
        donateUrl: 'https://www.example.com',
        secureNote: 'Secure & Tax Deductible',
    },
};

export function getDonationData(language) {
    return donationData[language === 'he' ? 'he' : 'en'];
}

export default donationData;
